<template>
  <div>
    <div class='list-itme-tail d-flex align-items-center py-1 title'>
      <div>
        <router-link :to="'/group/index/'+data.groupinfo_groupinfoID.id" class="name d-flex align-self-center">
          <!--        <el-popover-->
          <!--            placement="top-start"-->
          <!--            :width="340"-->
          <!--            trigger="hover"-->
          <!--            :open-delay="700"-->
          <!--        >-->

          <!--          <Group-Infor-Card :data="data" type="small" @opendialog="$refs.dialog.isLogin()">-->

          <!--          </Group-Infor-Card>-->
          <!--      <div class="d-flex align-self-center" slot="reference">-->
          <el-avatar shape="square"
                     :src="data.groupinfo_groupinfoID.avatar"
                     :size="35"
                     style="height: 35px;margin-right: 5px"
          >
            <span style="font-size:18px">{{ data.groupinfo_groupinfoID.name.substring(0, 1).toUpperCase() }}</span>
          </el-avatar>
          <span style="width: 96px"  class="text-truncate">{{ data.groupinfo_groupinfoID.name | textTrans }}</span>
          <!--      </div>-->
          <!--        </el-popover>-->
        </router-link>
      </div>
      <!--     作者   <small class="text-muted mx-2">{{$t('message').article.post}}</small>-->
<!--      <small class="text-muted h6 mt-2 font-weight-normal mx-2 mr-2">{{ $t('message').article.author }}</small>-->
      <div>
        <el-popover
            placement="top-start"
            :width="340"
            trigger="hover"
            :open-delay="700"
        >
          <User-Infor-Card :data="data" type="small" @opendialog="$refs.dialog.isLogin()">
          </User-Infor-Card>
          <!--        </el-popover>-->
          <a slot="reference" v-if="$store.state.user.check_is_wxc_domain()"
             :href="'https://passport.wenxuecity.com/members/index.php?act=profile&cid='+data.userinfo_userID.username">
            <div class="group-small d-flex align-self-center">
              <div v-if="!data.userinfo_userID.avatar" class="avatar-word mr-1">{{
                  data.userinfo_userID.first_letter
                }}
              </div>
              <img style="width: 35px;height: 35px"
                   v-if="data.userinfo_userID.avatar"
                   v-bind:alt="data.userinfo_userID.username"
                   class="rounded-circle mr-1"
                   v-bind:src="data.userinfo_userID.avatar"
              >
              <div class="name text-truncate" style="max-width: 70px">{{ data.userinfo_userID.username| textTrans }}</div>
            </div>
          </a>
          <router-link
              slot="reference"
              v-else
              :to="'/userindex/'+data.userID">
            <!--              <el-popover-->
            <!--                  placement="top-start"-->
            <!--                  :width="340"-->
            <!--                  trigger="hover"-->
            <!--                  :open-delay="700"-->
            <!--              >-->
            <!--                <User-Infor-Card :data="data" type="small" @opendialog="$refs.dialog.isLogin()">-->
            <!--                </User-Infor-Card>-->
            <div class="group-small d-flex align-self-center">
              <div class="group-small d-flex align-self-center">
                <div v-if="!data.userinfo_userID.avatar" class="avatar-word mr-1">{{
                    data.userinfo_userID.first_letter
                  }}
                </div>
                <img style="width: 35px;height: 35px"
                     v-if="data.userinfo_userID.avatar"
                     v-bind:alt="data.userinfo_userID.username"
                     class="rounded-circle mr-1"
                     v-bind:src="data.userinfo_userID.avatar"
                >
                <!--              </router-link>-->

                <div class="name">{{ data.userinfo_userID.username| textTrans }}</div>
              </div>
            </div>
          </router-link>
        </el-popover>
      </div>
      <div class="tail-data" style="width: 100px">
        {{data.create_date * 1000 | formatDate }}
      </div>
      <div class="tail-data ml-3 text-truncate" style="max-width: 110px">阅读{{data.postInfo_postID.count_read}} </div>
      <div  class="tail-data ml-3">评论{{data.postInfo_postID.count_comment}}
        <span v-if="data.postInfo_postID.comment_date!=0">
          .最新.{{data['postInfo_postID']['comment_date'] * 1000 | formatDate }}
        </span>
      </div>
    </div>
    <div class="list-itme d-flex bg-content">
      <div class="flex-fill">
        <router-link
            :to="'../../group/p/'+data.groupinfo_groupinfoID.id+'?topicID='+data.postInfo_postID.topicID+'&postID='+data.postID">
          <h4 class='article-title'>{{ data.postInfo_postID.title | textTrans }}</h4>
          <p class="descript" v-html="$options.filters.textTrans(data.postInfo_postID.msgbody)"></p>
        </router-link>
      </div>
      <div
          id="image"
          class='list-itme-image'
          v-if="data.postInfo_postID.pic"
          v-bind:style="{backgroundImage:'url('+data.postInfo_postID.pic+')'}">
        <router-link
            :to="'../../group/p/'+data.groupinfo_groupinfoID.id+'?topicID='+data.postInfo_postID.topicID+'&postID='+data.postID">
          <div class="imgspace" id="imgspace"></div>
        </router-link>
      </div>
    </div>

  </div>
</template>
<script>

import icons from '@/components/Icons/Icons.js'
import {textTrans} from '@/directives/textTrans.js';
import UserInforCard from '@/module/user/components/UserInforCard';
import {formatDate} from '@/directives/formatDate.js';


export default {
  name: 'article-list-item',
  props: {
    type: String,
    data: {
      countinfo_postID: {},
      create_date: Number,
      id: Number,
      postID: Number,
      postInfo_postId: {},
      title: String,
      userID: Number,
      userinfo_userID: {}
    }
  },
  components: {
    // IconV,
    UserInforCard,
    // GroupInforCard
  },
  data() {
    return {
      icons: icons,
      domain: '',
    }
  },
  methods: {
    deletBookmark(postID) {
      this.$emit('delete-bookmark', postID);
    },
    // article_delete(item){
    //   blog.article_delete(item.postID,0).then(res=>{
    //     if(res.status){
    //       this.$forceUpdate()
    //     }
    //   })
    // },
    // gotoEditor(item){
    //   let url = '/blog/my/editor/?postid='+item.postID
    //   this.$router.push(url);
    // }
  },
  created: function () {
    this.domain = location.host;

  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, 'yyyy-MM-dd');
      // return formatDate(date, 'yyyy-MM-dd hh:mm');
    },
    textTrans(string) {
      return textTrans(string);
    }
  },
  openModal() {
    if (this.$store.state.user.userinfo.UserID !== undefined) {
      this.modals.sendQqhModal = true
    } else {
      this.$router.push({path: "/login", query: {redirect: this.$route.fullPath}})
    }
  },
  sendQqh(data) {
    this.send(this.$store.state.user.userinfo.id, 2000004, this.modals.qqhMsgbody);
  },
  async send(userID, touserID, msgbody) {
    let user = this.$store.state.user;
    let res = await user.sendQqh(userID, touserID, msgbody);

    this.modals.modalData = res

    setTimeout(() => {
      this.modals.modalData = undefined;
      this.modals.sendQqhModal = res.status ? false : true;
    }, 4000)
  },

};
</script>
<style>
/*h4 {*/
/*  margin-top: 0 !important;*/
/*}*/

.group-small img {
  border: 1px solid #eee;
  /*box-shadow: 0 3px 8px 0 rgb(0 0 0 / 17%);*/
  cursor: pointer;
}

.group-small img:hover {
  opacity: 0.6;
}

.avatar-word, .small .avatar-word {
  border-radius: 50%;
  background-color: #eeeeee;
  line-height: 35px;
  min-width: 35px;
  text-align: center;
  font-weight: 500;
  -webkit-box-shadow: rgb(0 0 0 / 2%) 0px 0px 2px inset;
  box-shadow: rgb(0 0 0 / 2%) 0px 0px 2px inset;
  cursor: pointer;
  color: #6c757d;
}

.avatar-word, .small .avatar-word:hover {
  background-color: #eeeeee;
}

.list-itme {
  border-bottom: 1px solid #eee;
  margin-top: 0px;
}

.list-itme .list-itme-image {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border-radius: 4px;
  margin: auto 0 0 0.85rem;
}

.list-itme a {
  color: #14171a;
  text-decoration: none;
}

.imgspace {
  width: 160px;
  height: 105px;
}

h4.article-title {
  margin-bottom: .5rem;
  margin-top: 0;
  font-weight: 600;
  font-size: 1.2em
}

h4.article-title:hover, .name.el-popover__reference:hover {
  color: #235592
}

.list-itme .descript {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.list-itme .descript:hover {
  color: #646464
}

p.descript, div.list-itme-tail {
  color: #121212;
  line-height: 1.6;
  font-size: 1rem;
  font-weight: normal;
}

.list-itme-tail .name, .list-itme-tail .name a {
  color: #333;
  cursor: pointer;
  height: 36px;
  line-height: 35px;
  /*width: 113px;*/
  vertical-align: text-bottom;
  margin-right: 10px;
}

.list-itme-tail .hover {
  color: #027C04
}

.list-itme-tail .tail-data {
  font-size: 0.90rem;
  padding-right: 1rem;
  /*padding-top: 8px;*/
  color: #999999;
}

.list-itme-tail .tail-data a {
  cursor: pointer;
}

.tail-data .icons svg {
  stroke: gray;
  height: 16px;
  width: 16px;
}

p.descript {
  margin-bottom: 0.25rem;
}

small {
  font-size: 80%;
}

@media (max-width: 575.98px) {
  .list-itme .list-itme-image {
    margin: auto 0;
    margin-left: .5rem;
  }

  .imgspace {
    width: 90px;
    height: 90px;
  }
}
</style>
